import { useState, useCallback } from "react";
import { getDocumentsByDeviceId } from "../api/documents";

export const useDeviceDocuments = (deviceId) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadDocuments = useCallback(async () => {
    if (!deviceId) return;

    setLoading(true);
    setError(null);

    try {
      const result = await getDocumentsByDeviceId(deviceId);
      setDocuments(result.data || []);
    } catch (err) {
      console.error("Failed to load device documents:", err);
      setError(err.message || "Failed to load documents");
      setDocuments([]);
    } finally {
      setLoading(false);
    }
  }, [deviceId]);

  const refreshDocuments = useCallback(() => {
    loadDocuments();
  }, [loadDocuments]);

  return {
    documents,
    loading,
    error,
    loadDocuments,
    refreshDocuments,
  };
};
